import { DateTime } from "luxon";
import {
  LuxonDateFormats,
  type LuxonDateFormat,
} from "shared/datetime/dateFormats";
/**
 * Formats a date using the Luxon library.
 *
 * @param {string|Date} date - The date to format.
 * @param {LuxonDateFormat} format - The format to use.
 * @param {string} zone - The time zone to use.
 * @returns {string} The formatted date as string.
 */
export const formatLuxonDate = (
  date: string | Date | null | undefined,
  format?: LuxonDateFormat,
  zone?: string,
): string => {
  if (!format) {
    format = LuxonDateFormats.D;
  }
  if (!date) {
    return "";
  }

  const isoDate = DateTime.fromISO(date.toString(), {
    zone: zone ?? "America/Chicago",
  });
  if (!isoDate.isValid) {
    return "";
  }

  return isoDate.toFormat(format);
};
